import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Checkbox } from '../../../components/Checkbox';
import { ChevronRight } from '../../../components/Icon';
import { PageHeader } from '../../../components/PageHeader';
import { Sort } from '../../../components/Sort';
import { CompanyStatusCard } from '../components/StatusLabel';
import { getPropByName } from '../../../utils/props';
import { COLOR_TABLE_HEADER, COLOR_HEADER } from '../../../vars';
import { selectWorks } from '../../Api/selectors';
import {
  fetchCompanies,
  changeCompanyFilter,
  addCompanyToBulkActionsList,
  removeCompanyFromBulkActionsList,
  changeCompanySortOrder,
} from '../actions';
import { Companiesearch } from '../components/Search';
import { REQUEST_COMPANIES } from '../constants';
import {
  selectCompanies,
  selectCompaniesBulkActionsList,
  selectCompanyCount,
  selectCompanyFilter,
  selectCompanyPaginator,
} from '../selectors';
import { UserLabelById } from '../../Users/components/UserLabelById';
import { setScrollPosition } from '../../Actions/actions';
import { CompanyQuickCreator } from './QuickCreate';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { ViesLabel } from '../components/ViesLabel';
import LoadingFilters from '../../../containers/App/Components/LoadingFilters/LoadingFilters';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';
import { BulkActionsCompanyCard } from './BulkActions/BulkActionsCard';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../translate-countries';
import { isShowViesCheck } from '../helpers';
import s from './overview.module.css';
import cn from 'classnames';

const Container = styled.div`
  .rows {
    font-size: 12px;
  }
  .col-name {
    font-weight: bold;
  }
  .filters {
    padding: 24px;
    background-color: white;
    margin-bottom: 22px;
  }

  .rows {
    .check-col {
      min-width: 40px;
      text-align: center;
    }
    background-color: white;
    .header {
      background-color: ${COLOR_TABLE_HEADER};
      .box {
        height: 52px;
        white-space: nowrap;
        flex-shrink: 0;
        > div {
          font-weight: 600;
        }
      }
    }

    .header-col {
      width: auto;
      width: 110px;
      overflow: hidden;

      text-transform: capitalize;

      &.col-info {
        justify-content: center;
      }
    }

    .item-cell {
      padding: 4px;
      width: 120px;

      &:last-child {
        justify-content: flex-end;
      }
    }

    .col-check {
      text-align: center;
      width: 40px;
    }

    .col-name {
      padding: 16px 0;
      width: 200px;
    }

    .col-address {
      width: 300px;
    }

    .col-company_email_address {
      width: 200px;
    }

    .col-accountmanager {
      width: 200px;
      white-space: nowrap;
    }

    .col-customernumber {
      width: 150px;
    }

    .item-row {
      border-bottom: 1px solid ${COLOR_HEADER};
    }
  }
`;
/* eslint-disable react/prefer-stateless-function */

const STATE = {
  sort: null,
  sort_direction: 'up',
  currentPage: 0,
  quickCreate: false,
};

/* eslint-disable react/prefer-stateless-function */
class CompaniesOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      sort: props.filter.sortType || null,
      sort_direction: (props.filter.order === 'desc' ? 'up' : 'down') || 'up',
    });
  }

  componentDidMount() {
    if (this.state.sort === 'country') {
      this.props.fetch();
    }
  }

  get isShowDeletedStatusItems() {
    const deletedStatusValue = '5';
    const hasFilterDeleted = this.props.filter?.properties
      ?.find(p => p.key === 'status')
      ?.value?.includes(deletedStatusValue);

    return hasFilterDeleted;
  }

  get companies() {
    return this.isShowDeletedStatusItems
      ? this.props.companies?.filter(v => v)
      : this.props.companies?.filter(v => v)?.filter(v => v.status !== '5');
  }

  get locale() {
    return this.props.locale;
  }

  selectPage = newPage => {
    const newOffset = newPage * this.props.paginator?.limit ?? 0;
    this.props.setScrollPosition(null);
    this.setState({ currentPage: newPage }, this.props.changeFilter(newOffset));
  };

  cols() {
    return [
      { label: 'name', sort: true },
      { label: 'address', sort: true },
      { label: 'country', sort: true },
      { label: 'accountmanager', sort: true },
      { label: 'customernumber', sort: true },
      { label: 'status', sort: false },
      { label: 'vies', sort: false },
    ];
  }

  getContactString(company) {
    if (!company.users?.[0]) return null;
    let name = (
      getPropByName(company.users?.[0], 'name', '') +
      ' ' +
      getPropByName(company.users?.[0], 'surname', '')
    ).trim();
    if (!name) name = getPropByName(company.users?.[0], 'email_address', '');
    return name;
  }

  handleClick(event, itemId) {
    // this.props.setScrollPosition(`#item${itemId}`);
    this.to(`/companies/${itemId}`, event?.ctrlKey || event?.metaKey);
  }

  handleTableRowClick(event, itemId) {
    this.props.setScrollPosition(`#item${itemId}`);
    // this.to(`/companies/${itemId}`, event?.ctrlKey || event?.metaKey);
    const excludeElements = ['input', 'img'];
    const targetElement = event.target.tagName.toLowerCase();
    if (!excludeElements.includes(targetElement)) {
      this.handleClick(event, itemId);
    }
  }

  isSelectedCompany(companyId) {
    return this.props.bulkActionsList?.filter(item => item?.id === companyId)?.length == 1;
  }

  onSelectCompany(e, company) {
    e.stopPropagation();

    if (this.isSelectedCompany(company?.id)) {
      return this.props.removeCompanyFromBulkActionsList(company?.id);
    }
    return this.props.addCompanyToBulkActionsList(company);
  }

  onSelectAll(e, companies) {
    e.stopPropagation();
    return companies?.filter(company => this.props.addCompanyToBulkActionsList(company));
  }

  onRemoveAll(e, companies) {
    e.stopPropagation();
    return companies?.filter(company => this.props.removeCompanyFromBulkActionsList(company?.id));
  }

  sortOn(field) {
    let direction = 'none';
    if (this.state.sort === field) {
      if (this.state.sort_direction === 'none') direction = 'up';
      if (this.state.sort_direction === 'up') direction = 'down';
    } else {
      direction = 'up';
    }
    this.setState({ sort: field, sort_direction: direction });

    this.props.changeCompanySortOrder(
      direction === 'none' ? null : field,
      direction === 'none' ? null : direction === 'up' ? 'desc' : 'asc',
    );
  }

  renderRow(company) {
    return (
      <tr
        className={`align-middle ${s.thead}`}
        key={company.id}
        id={`item${company.id}`}
        onClick={event => this.handleTableRowClick(event, company.id)}
      >
        <td className={s.bodyTd}>
          <div className={s.checkboxContainerTd}>
            <CheckboxComponent
              checked={this.isSelectedCompany(company?.id)}
              onChange={e => this.onSelectCompany(e, company)}
            />
          </div>
        </td>

        {this.cols().map(({ label }) => (
          <td className={s.bodyTd}>{this.renderCell(label, company)}</td>
        ))}
      </tr>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      default:
        return this.lbl(`companies.overview.column.${col}`);
    }
  }

  renderCell(col, company, vies) {
    const address = company.addresses?.find(a => a.type?.name === 'home') || company.addresses?.[0];
    const fn = () => {
      switch (col) {
        case 'contact1':
          return this.getContactString(company);
          break;
        case 'address':
          if (!address) return '';
          return address.addressLine1 + ', ' + address.city;
        case 'country':
          return translateCountry(address?.country?.name, this.locale) || '';
        case 'name':
          return (
            <>
              {company['company_type'] === 'company'
                ? company['name'] || ''
                : `${company.name || ''} ${company.surname || ''}`}
              <br />
              {/* <KanbanProgressBar type="company" target={company} /> */}
            </>
          );
        case 'company_email_address':
          return company['company_type'] == 'company' ? company['company_email'] : company['email'];
        case 'accountmanager':
          return <UserLabelById user_id={company.account_manager_user_id} company_overview={true} />;

        // return `${getPropByName(company.accountManager, 'name')} ${getPropByName(company.accountManager, 'surname')}`;
        case 'customernumber':
          return company['customernumber'];
        case 'status':
          return (
            company.status && (
              <CompanyStatusCard status={company.status}>
                {this.lbl(`company.property.status.${company.status}`)}
              </CompanyStatusCard>
            )
          );
        case 'vies':
          return (
            isShowViesCheck(company?.company_type, company?.company_from_eu) && <ViesLabel vies={company?.viesCheckStatus} />
          );
        default:
          return company[col];
      }
    };

    return (
      <div className={`item-cell col-${col}`} key={`${col}-${company.id}`}>
        {fn()}
      </div>
    );
  }

  renderCard = (company, idx) => {
    if (!idx) console.dir(company);

    const address = company?.addresses?.find(a => ['home', 'visiting'].indexOf(a.type?.name) > -1) ?? '';
    const addressLine = address ? `${address?.addressLine1}  ${address?.postcode} ${address?.city}` : ' -';

    return (
      <VBox
        vCenter
        left
        key={company.id ?? `company${idx}`}
        id={`item${company?.id}`}
        onClick={event => this.handleClick(event, company?.id)}
        style={{ margin: '10px 0' }}
      >
        <HBox vCenter style={{ padding: 10, borderBottom: '1px solid #eee' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox checked={this.isSelectedCompany(company?.id)} onChange={e => this.onSelectCompany(e, company)} />
            <span style={{ textAlign: 'left' }}>
              <strong>{company?.name ?? 'Unknown Company Name'}</strong>
            </span>
          </div>
          <div style={{ backgroundColor: company.status === '5' ? '#FF0000' : 'black', color: 'white', padding: 2 }}>
            {this.lbl(`company.property.status.${company.status}`) ?? '-'}
          </div>
        </HBox>
        <VBox style={{ padding: '12px', borderBottom: '1px solid #eee', width: '100%', gap: 10 }}>
          <div>
            <strong>Address: </strong> {addressLine}
          </div>
          <div>
            <strong>Country: </strong> {translateCountry(address?.country?.name, this.locale) ?? ' -'}
          </div>
          <div>
            <strong>Contact: </strong> {this.getContactString(company)}
          </div>
          <div>
            <strong>Email: </strong> {company?.company_email ?? ' -'}
          </div>
          <div>
            <strong>Account Manager: </strong> <UserLabelById user_id={company.accountManagerId} />
          </div>
          {/* <KanbanProgressBar type="company" target={company} /> */}
        </VBox>
      </VBox>
    );
  };

  render() {
    if (this.props.work)
      return (
        <>
          <PageHeader
            title={
              <>
                {this.lbl('companies.overview.title')} <span className="label number">{this.props.count}</span>
              </>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('companies.overview.title')}
              </>
            }
          />
          <LoadingFilters />
        </>
      );
    return (
      <Container>
        {this.state.quickCreate && <CompanyQuickCreator resetQuickModal={() => this.setState({ quickCreate: false })} />}
        {!!this.props.bulkActionsList?.length && <BulkActionsCompanyCard bulkActionsList={this.props.bulkActionsList} />}
        <PageHeader
          title={
            <>
              {this.lbl('companies.overview.title')} <span className="label number">{this.props.count}</span>
            </>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('companies.overview.title')}
            </>
          }
        />
        <div className="d-flex justify-content-end">
          <Button primary small onClick={() => this.to('/companies/create/1')}>
            +{this.lbl('create_company')}
          </Button>
          <Button primary small onClick={() => this.setState({ quickCreate: true })}>
            +{this.lbl('quick_create')}
          </Button>
        </div>
        <div className="filters">
          <HBox right></HBox>
          <VBox left vCenter>
            <Companiesearch />
          </VBox>
        </div>
        {window.innerWidth <= 768 ? (
          this.companies?.filter(v => v).map((company, idx) => <div className="rows">{this.renderCard(company, idx)}</div>)
        ) : (
          <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
            <thead className="align-middle">
              <tr className={cn('align-middle', s.thead)}>
                <th className={s.headTh}>
                  <CheckboxComponent
                    disabled={this.props.weblogin}
                    checked={this.state.allSelected == '1'}
                    onChange={e => {
                      if (this.state.allSelected == '1') {
                        this.setState({ allSelected: '0' });
                        return this.onRemoveAll(e, this.props?.companies);
                      }
                      this.setState({ allSelected: '1' });
                      return this.onSelectAll(e, this.props?.companies);
                    }}
                  />
                </th>
                {this.cols().map(({ label: col, sort }, index) => (
                  <th className={s.headTh} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                    <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                      {this.renderHeaderCell(col)}

                      {sort && (
                        <Sort
                          direction={
                            this.props.filter?.sortType == col
                              ? this.props.filter?.order === 'desc'
                                ? 'up'
                                : 'down'
                              : 'none'
                          }
                        />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>{this.companies.filter(v => v).map(company => this.renderRow(company))}</tbody>
          </table>
        )}
        {!!this.props.companies?.length && this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          <div className="d-flex justify-content-center mt-2 mb-5 mb-md-0">
            <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
          </div>
          // {!!this.companies?.length && this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          //   <Pagination paginator={this.props.paginator} selectPage={this.selectPage} />
        )}
      </Container>
    );
  }
}

CompaniesOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    companies: selectCompanies(),
    count: selectCompanyCount(),
    paginator: selectCompanyPaginator(),
    bulkActionsList: selectCompaniesBulkActionsList(),
    work: selectWorks([REQUEST_COMPANIES]),
    filter: selectCompanyFilter(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchCompanies());
    },
    changeFilter(offset) {
      dispatch(changeCompanyFilter('offset', offset));
    },
    addCompanyToBulkActionsList(company) {
      dispatch(addCompanyToBulkActionsList(company));
    },
    removeCompanyFromBulkActionsList(companyId) {
      dispatch(removeCompanyFromBulkActionsList(companyId));
    },
    setScrollPosition(itemId) {
      dispatch(setScrollPosition(itemId));
    },
    changeCompanySortOrder(sortType, order) {
      dispatch(changeCompanySortOrder(sortType, order));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompaniesOverview = compose(withConnect, withRouter)(CompaniesOverviewComp);
